<template>
	<div class="row h-100">
		<div class="col-12">
			<div class="card h-100">
				<div class="card-header bg-info text-light">
					File Upload & Download
				</div>
				<div class="card-body p-0">
					<div ref="container" class="container-fluid p-0 m-0 h-100 box-sizing-reset"></div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import fromCDN from 'from-cdn'

export default {
  name: 'FilesApp',
  components: {},
  mounted: function () {
    const self = this

    // this will not wait for css to complete before resolving
    fromCDN([
      // css
      process.env.BASE_URL + 'dhtmlx/suite.min.css',
      process.env.BASE_URL + 'css/common.css',

      // js (libs/utils)
      process.env.BASE_URL + 'dhtmlx/suite.min.js',
      process.env.BASE_URL + 'js/lib/emitter.js',
      process.env.BASE_URL + 'js/lib/papaparse.min.js',
      process.env.BASE_URL + 'js/utils/polyfills.js',
      process.env.BASE_URL + 'js/utils/peiutils.js',
      process.env.BASE_URL + 'js/utils/peiajax.js'
    ])
      .then(_ => fromCDN([ process.env.BASE_URL + 'js/utils/peidhtmlx.js' ])) // this is loaded after because it depends on dhtmlx objects and peiutils
      .then(_ => fromCDN([
        process.env.BASE_URL + 'js/filesApp.js'
      ]))
      .then(_ => {
      /* globals _filesApp */
        var files = new _filesApp(self.$refs.container, process.env.BASE_URL)
        files.init()
      })
  }
}

</script>
<style>

</style>
